<script>
  import { urlServeur } from "./conf";
  import { onMount } from "svelte";

  let brutRows;
  let rows = [];
  let tabKeys = [];

  const fetchData = async () => {
    const response = await fetch(urlServeur + "/api/immeubles/tdb/");
    const result = await response.json();
    brutRows = result.payload.emprunt;

    // Ajoute un index unique, pour eviter l'erreur cle unique dans carbon-table
    // brutRows.forEach((item, index) => {
    //  item.id = index;
    //   item.du = Math.round(item.du);
    //  });
    tabKeys = Object.keys(brutRows);
    rows = Object.values(brutRows);
    // console.log(tabKeys);
    // console.log(rows);
  };
  /**
   *
   */
  onMount(async () => {
    await fetchData();
  });
</script>

<div class="container">
  <div class="table-responsive col-xl-12" align="center">
    <table width="100%" class="table table-primary table-bordered border-primary emprunts">
      <thead>
        <tr>
          <th>Nom</th>
          <th>Total</th>
          <th>int dû</th>
          <th>total temp</th>
          <th>Délai</th>
          <th>Du</th>
        </tr>
      </thead>
      <tbody>
        {#each rows as row, i}
          <tr class={tabKeys[i] == "total" ? "bg-info" : ""}>
            <td>{tabKeys[i]}</td>
            <td>
              {Math.round(row.total)}
            </td>
            <td>
              {new Intl.NumberFormat("fr-FR").format(Math.round(row.int_du))}
            </td>
            <td>
              {new Intl.NumberFormat("fr-FR").format(Math.round(row.total_emp))}
            </td>
            <td>
              {new Intl.NumberFormat("fr-FR").format(Math.round(row.delai))}
            </td>
            <td>{new Intl.NumberFormat("fr-FR").format(Math.round(row.du))}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>

<style>
  .emprunts {
    font-size: 0.85em;
    text-align: right;
  }
</style>
